import type { UserResource } from "@clerk/types";

export type {
    MemberObject
} from "@neum/frontend-shared/types/memberTypes";

export {
    ALL_DOCTORS,
    allDoctors,
    sortMembersList
} from "@neum/frontend-shared/types/memberTypes";

export function getUserFlag(
    user: UserResource | null | undefined,
    flag: string,
    default_value: boolean = false
): boolean {
    const user_flags = user?.publicMetadata["flags"] as Record<string, boolean>;
    return user_flags ? user_flags[flag] ?? default_value : default_value;
}
